import React from "react"

import * as s from "./BlogHeader.module.scss"

export const BlogHeader = ({ category, date, title, image, mainColor }) => {
  return (
    <div
      className={`${s.Wrapper} ${image && s.Wrapper___withImage}`}
      style={
        image
          ? { backgroundImage: `url(${image})` }
          : mainColor
          ? { background: mainColor }
          : {}
      }
    >
      <div className={s.Inner}>
        <span
          className={`${s.BlogSubHeader} ${
            image && s.BlogSubHeader___inverted
          }`}
        >
          {category} / {date}
        </span>
        <h1 className={`${s.BlogHeader} ${image && s.BlogHeader___inverted}`}>
          {title}
        </h1>
      </div>
    </div>
  )
}
